<template>
    <div class="header">
        <div class="container-fluid">
            <div class="mt-4">
                <div class="card">
                    <div class="card-body">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">Genta/Gendis</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <!-- Card  -->
            <div class="card mt-5">
                <div class="card-header">
                    <!-- Title -->
                    <h4 class="card-header-title">Genta/Gendis List</h4>
                    <!-- Button -->
                    <b-button v-b-modal.modal-1 variant="primary" @click="pushAdd()" v-if="rolemap == 'Super Admin'">
                        <span class="fe fe-file-plus"></span>
                        Genta/Gendis
                    </b-button>
                </div>
                <div class="card-body">
                    <div class="d-flex flex-column flex-md-row justify-content-between flex-wrap mb-3">
                        <!-- Left: Search -->
                        <div class="d-flex align-items-center mb-2 mb-md-0">
                            <label class="mb-0 mr-2">Search</label>
                            <b-form-input v-model="body.search" class="w-100 w-md-auto" placeholder="Type Here..."
                            @input="getListgg()"/>
                        </div>

                        <!-- Right: Page size selector -->
                        <div class="d-flex align-items-center">
                            <label class="mb-0 mr-2">Show</label>
                            <v-select v-model="body.pageSize" @input="getListgg" 
                                style="min-width: 100px; width: 100%; max-width: 120px" :options="[5, 10, 50, 100]"
                                :clearable="false" />
                        </div>
                    </div>
                    <vue-good-table 
                        mode="remote"
                        :line-numbers="false" 
                        :columns="filteredColumns" 
                        :rows="ggList.data" 
                        :total-rows="ggList.total"
                        :sort-options="{
                            enabled: false,
                        }" 
                        :pagination-options="{
                            enabled: true,
                            perPage: body.pageSize,
                        }" 
                        style-class="vgt-table table table-bordered" 
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPageChange">
                        <!-- Loading -->
                        <div slot="emptystate" class="text-center font-size-14">
                            No data available
                        </div>
                        <!-- Custom Rows -->
                        <template slot="table-row" slot-scope="props">
                            <!-- Table Action -->
                            <span v-if="props.column.field == 'action'">
                                <!-- <b-button
                                    v-if="rolemap == 'Super Admin'"
                                    class="no-wrap btn-pill"
                                    variant="warning"
                                    size="sm"
                                    @click="updateData(props.row)"
                                >
                                    <span class="fe fe-edit"></span>
                                </b-button> -->
                                <b-button
                                    v-if="rolemap == 'Super Admin'"
                                    class="no-wrap ml-2"
                                    variant="danger"
                                    style="margin-left: 5px"
                                    size="sm"
                                    @click="deleteData(props.row.nik)"
                                >
                                    <span class="fe fe-trash-2"></span>
                                </b-button>
                                <!-- <b-button class="no-wrap btn-pill ml-2 text-white" variant="info" size="sm" :to="{
                                        name: `ideationDetails`,
                                        params: { id: props.row.id, data: props.row },
                                    }">
                                    <span class="fe fe-info"></span>
                                </b-button> -->
                            </span>
                            <span v-else-if="props.column.field === 'date'">
                                {{ convertDate(props.row.created_at) }}
                            </span>
                            <span v-else-if="props.column.field === 'no'">
                                <p class="text-center ">{{ props.row.no }}</p>
                            </span>
                        </template>
                        <template slot="pagination-bottom" slot-scope="props">
                            <div class="d-flex justify-content-end">
                                <div>
                                    <b-pagination :value="1" :total-rows="ggList.total" :per-page="body.pageSize" first-number last-number
                                        align="right" prev-class="prev-item" next-class="next-item" class="m-3"
                                        @input=" (value) => props.pageChanged({ currentPage: value })">
                                    </b-pagination>
                                </div>
                            </div>
                        </template>
                    </vue-good-table>
                </div>
            </div>

            <!-- Modal  -->
            <b-modal id="modal-1" hide-footer title="Genta/Gendis Form">
                <form @submit.prevent="saveAdd()" v-if="isAdd === true">
                    <div class="form-group">
                        <label>Name <span class="text-danger">*</span></label>
                        <v-select
                            v-model="modalCreate.fullname"
                            :options="listEmployee"
                            label="fullname"
                            :reduce="(e) => e"
                            @input="nikAddSelect()"
                            @search="nikSearch"
                            v-validate="'required'"
                            name="Name"
                        />
                        <span class="text-sm text-danger" v-show="errors.has('Name')">{{
                            errors.first("Name")
                        }}</span>
                    </div>
                    <div class="form-group" v-if="modalCreate.nik !== ''">
                        <label>NIK <span class="text-danger">*</span></label>
                        <v-select
                            v-model="modalCreate.nik"
                            :options="listEmployee"
                            label="nik"
                            disabled
                            :reduce="(e) => e.nik"
                            v-validate="'required'"
                            name="NIK"
                        />
                        <span class="text-sm text-danger" v-show="errors.has('NIK')">{{
                        errors.first("NIK")
                        }}</span>
                    </div>
                    <div class="form-group" v-if="modalCreate.position !== ''">
                        <label>Jabatan <span class="text-danger">*</span></label>
                        <v-select
                        v-model="modalCreate.position"
                        :options="listJabatan"
                        label="name"
                        disabled
                        :reduce="(e) => e.id"
                        v-validate="'required'"
                        name="Jabatan"
                        />
                        <span class="text-sm text-danger" v-show="errors.has('Jabatan')">{{
                        errors.first("Jabatan")
                        }}</span>
                    </div>
                    <div class="form-group" v-if="modalCreate.company !== ''">
                        <label>Business Unit <span class="text-danger">*</span></label>
                        <v-select
                        disabled
                        v-model="modalCreate.company"
                        :options="optionType"
                        label="label_name"
                        :reduce="(e) => e.id"
                        v-validate="'required'"
                        name="Business Unit"
                        />
                        <span
                        class="text-sm text-danger"
                        v-show="errors.has('Business Unit')"
                        >{{ errors.first("Business Unit") }}</span
                        >
                    </div>
                    <div class="form-group" v-if="modalCreate.division !== ''">
                        <label>Division <span class="text-danger">*</span></label>
                        <v-select
                        disabled
                        v-model="modalCreate.division"
                        :options="listDivision"
                        label="name"
                        :reduce="(e) => e.id"
                        v-validate="'required'"
                        name="Division"
                        />
                        <span class="text-sm text-danger" v-show="errors.has('Division')">{{
                        errors.first("Division")
                        }}</span>
                    </div>
                    <div class="form-group" v-if="modalCreate.department !== ''">
                        <label>Departement </label>
                        <v-select
                        v-model="modalCreate.department"
                        :options="listDepartement"
                        label="department"
                        :reduce="(e) => e.department"
                        v-validate="'required'"
                        name="Depaetement"
                        />
                    </div>
                    <div class="form-group">
                        <button
                        style="margin-left: auto; float: right"
                        class="mt-4 btn btn-primary"
                        type="submit"
                        v-if="isLoading == false"
                        >
                        Save
                        </button>
                        <button
                        style="margin-left: auto; float: right"
                        class="mt-4 btn btn-primary"
                        type="button"
                        disabled
                        v-else
                        >
                        <span
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                        ></span>
                        Loading...
                        </button>
                    </div>
                </form>

                <form @submit.prevent="saveUpdate()" v-else>
                <div class="form-group">
                    <label>NIK <span class="text-danger">*</span></label>
                    <v-select
                        v-model="modalUpdate.nik"
                        :options="listUser.data"
                        label="nik"
                        :reduce="(e) => e.nik"
                        @input="nikUpdateSelect()"
                        @search="nikSearch()"
                        v-validate="'required'"
                        name="NIK"
                    />
                    <span class="text-sm text-danger" v-show="errors.has('NIK')">{{
                    errors.first("NIK")
                    }}</span>
                </div>
                <div class="form-group">
                    <label>Name <span class="text-danger">*</span></label>
                    <v-select
                        v-model="modalUpdate.fullname"
                        :options="optionType"
                        label="label_name"
                        :reduce="(e) => e.id"
                        v-validate="'required'"
                        name="Name"
                    />
                    <span class="text-sm text-danger" v-show="errors.has('Name')">{{
                    errors.first("Name")
                    }}</span>
                </div>
                <div class="form-group">
                    <label>Position <span class="text-danger">*</span></label>
                    <v-select
                        v-model="modalUpdate.position"
                        :options="listJabatan.data"
                        label="name"
                        :reduce="(e) => e.id"
                        v-validate="'required'"
                        name="Jabatan"
                    />
                    <span class="text-sm text-danger" v-show="errors.has('Position')">{{
                    errors.first("Position")
                    }}</span>
                </div>
                <div class="form-group">
                    <label>Business Unit <span class="text-danger">*</span></label>
                    <v-select
                        v-model="modalUpdate.company"
                        :options="optionType"
                        label="label_name"
                        :reduce="(e) => e.id"
                        v-validate="'required'"
                        name="Business Unit"
                    />
                    <span
                    class="text-sm text-danger"
                    v-show="errors.has('Business Unit')"
                    >{{ errors.first("Business Unit") }}</span
                    >
                </div>
                <div class="form-group">
                    <label>Division <span class="text-danger">*</span></label>
                    <v-select
                    v-model="modalUpdate.division"
                    :options="listDivision.data"
                    label="name"
                    :reduce="(e) => e.id"
                    v-validate="'required'"
                    name="Division"
                    />
                    <span class="text-sm text-danger" v-show="errors.has('Division')">{{
                    errors.first("Division")
                    }}</span>
                </div>
                <div class="form-group">
                    <label>Depaetement</label>
                    <v-select
                    v-model="modalUpdate.department"
                    :options="listDepartement.data"
                    label="name"
                    :reduce="(e) => e.id"
                    v-validate="'required'"
                    name="Depaetement"
                    />
                </div>
                <div class="form-group">
                    <button
                    style="margin-left: auto; float: right"
                    class="mt-4 btn btn-primary"
                    type="submit"
                    v-if="isLoading == false"
                    >
                    Save
                    </button>
                    <button
                    style="margin-left: auto; float: right"
                    class="mt-4 btn btn-primary"
                    type="button"
                    disabled
                    v-else
                    >
                    <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                    ></span>
                    Loading...
                    </button>
                </div>
                </form>
            </b-modal>

        </div>
    </div>
</template>

<script>
    import axiosIns from "@/api/axios";
    export default {
        // eslint-disable-next-line vue/multi-word-component-names
        name: "Ideation",
        components: {},
        computed: {
            ggList() {
                return this.$store.getters["userData/ggList"];
            },
            employees() {
                return this.$store.getters["userData/employeeData"];
            },
            listUser() {
                return this.$store.getters["userData/requestorList"];
            },
            listJabatan() {
                return this.$store.getters["userData/listJabatan"];
            },
            filteredColumns() {
                let login = localStorage.getItem('role_map')
                if (login !== 'Super Admin') {
                    return this.columns.filter(col => col.field !== 'action');
                }
                return this.columns;
            }
        },
        data() {
            return {
                listBusiness: [],
                listDepartement: [],
                listEmployee: [],
                listDivision: [],
                optionType: [],
                rolemap: localStorage.getItem("role_map"),
                body: {
                    page: 1,
                    pageSize: 10,
                    search: "",
                    nik: "",
                    departement: "",
                    order: ""
                },
                isAdd: true,
                load: false,
                isLoading: false,
                modalCreate: {
                    nik: "",
                    fullname: "",
                    position: "",
                    company: "",
                    division: "",
                    department: "",
                },
                modalUpdate: {
                    id: "",
                    nik: "",
                    fullname: "",
                    position: "",
                    company: "",
                    division: "",
                    department: "",
                },
                columns: [
                    {
                        label: 'No',
                        field: 'no',
                        thClass: 'text-center'
                    },
                    {
                        label: 'Genta/Gendis Name',
                        field: 'name',
                    },
                    {
                        label: 'NIK',
                        field: 'nik',
                    },
                    {
                        label: 'Division',
                        field: 'divisi',
                    },
                    {
                        label: 'Departement',
                        field: 'department',
                    },
                    {
                        label: 'Head of Division',
                        field: 'headOfDiv',
                    },
                    {
                        label: 'Actions',
                        field: 'action',
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    }

                ],
            };
        },

        mounted() {
            this.getListgg()
            this.getUser()
            this.getBussiness()
            this.getDepartement()
        },
        methods: {
            pushAdd() {
                this.modalCreate = {
                    nik: "",
                    fullname: "",
                    position: "",
                    company: "",
                    division: "",
                    department: "",
                }
                this.isAdd = true
            },
            updateData(props) {
                this.$bvModal.show("modal-1");
                this.isAdd = false;
                this.ids = props.id;
                this.modalUpdate = props;
            },
            nikAddSelect() {
                const nik = { 
                    nik: this.modalCreate.fullname.nik,
                    limit: 10,
                    page: 1
                };
                this.$store.dispatch("userData/GET_ALL_REQUESTOR", nik).then(() => {
                    let data = this.$store.getters["userData/requestorList"];
                    this.modalCreate = {
                        nik: data[0]?.nik,
                        fullname: data[0].fullname,
                        position: data[0]?.position,
                        company: data[0]?.organizational_unit_name,
                        division: data[0]?.divisi,
                        department: data[0]?.department,
                    };
                });
            },

            async nikSearch(search) {
                const nik = { 
                    fullname: search,
                    limit: 10,
                    page: 1
                };
                this.$store.dispatch("userData/GET_ALL_REQUESTOR", nik).then(() => {
                    let data = this.$store.getters["userData/requestorList"];
                    this.listEmployee = data
                });
            },

            async nikFilter(search) {
                const nik = { 
                    nik: search,
                    limit: 10,
                    page: 1
                };
                this.$store.dispatch("userData/GET_ALL_REQUESTOR", nik).then(() => {
                    let data = this.$store.getters["userData/requestorList"];
                    this.listEmployee = data
                });
            },

            nikUpdateSelect() {
                const nik = { nik: this.modalUpdate.nik };
                this.$store.dispatch("userData/GET_ALL_REQUESTOR", nik).then(() => {
                    this.modalUpdate = {
                    id: this.ids,
                    nik: this.userByNik.data[0].nik,
                    fullname: this.userByNik.data[0].fullname,
                    position: this.userByNik.data[0].position_title,
                    company: this.userByNik.data[0].organizational_unit_name,
                    division: this.userByNik.data[0].divisi,
                    department: this.userByNik.data[0].department,
                    };
                });
            },

            saveAdd() {
                this.$validator.validateAll().then(async (res) => {
                    if (!res) return false;

                    try {
                        this.isLoading = true;
                        let data = {
                            nik: this.modalCreate.nik
                        }
                        this.$store.dispatch("gendtaGendis/CREATE_DATA", data)
                            .then((resp) => {
                                this.$swal("Saved", "Your input has been saved", "success").then(
                                    (resp) => {
                                    this.isLoading = false;
                                    (this.modalCreate = {
                                        nik: "",
                                        fullname: "",
                                        position: "",
                                        company: "",
                                        division: "",
                                        department: "",
                                    }),
                                    this.getListgg();
                                    this.$bvModal.hide("modal-1");
                                });
                            }).catch((err) => {
                                this.isLoading = false
                                this.$swal("Error", err.response.data.error, "error")
                            });
                    } catch (error) {
                        this.isLoading = false;
                        this.$swal("Error", error.response.data.error, "error");
                    }
                });
            },

            saveUpdate() {
                let body = {
                    id: this.ids,
                    data: { ...this.modalUpdate },
                };
                this.isLoading = true;
                this.$store
                    .dispatch("gendtaGendis/UPDATE_DATA", this.modalUpdate)
                    .then((resp) => {
                    this.$swal("Saved", "Your input has been saved", "success").then(
                        (resp) => {
                        this.isLoading = false;
                        (this.modalUpdate = {
                            nik: "",
                            fullname: "",
                            position: "",
                            company: "",
                            division: "",
                            departement: "",
                        }),
                            // this.getList();
                            this.$bvModal.hide("modal-1");
                        }
                    );
                    })
                    .catch((err) => {
                    this.$swal("Error", "Error while update data", "error");
                    });
            },

            deleteData(nik) {
                this.$swal({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#00D97E",
                    cancelButtonColor: "#E63757",
                    confirmButtonText: "Yes, delete it!",
                    cancelButtonText: "Cancel",
                }).then((result) => {
                    if (result.isConfirmed) {
                        if (nik == null) {
                          return this.$swal("Error", "Nik Null", "error");
                        }
                        this.$store.dispatch("gendtaGendis/DELETE_DATA", nik)
                            .then((resp) => {
                                this.getListgg();
                                this.$swal("Deleted!", "Your file has been deleted", "success");
                            })
                            .catch((resp) => {
                                this.$swal("Error", resp.response.data.error, "error");
                            });
                    }
                });
            },
            getUser() {
                let body = {
                    limit: 10,
                    page: 1
                }
                this.$store.dispatch("userData/GET_ALL_REQUESTOR", body);
            },
            getListgg() {
                this.$store.dispatch("userData/GET_ALL_GG", this.body)
            },
            getBussiness() {
                axiosIns.get(`https://api.ugems.id/sap-sync/organization`).then((resp) => {
                    this.listBusiness = resp.data.data
                })
            },
            getDepartement() {
                axiosIns.get(`https://api.ugems.id/sap-sync/departments`).then((resp) => {
                    this.listDepartement = resp.data.data
                })
            },

            // Pagination
            onPageChange(payload) {
                this.body.limit = payload.currentPerPage;
                this.body.page = payload.currentPage;
                this.getListgg();
            },
        },
    };
</script>